/* Dark homepage — shared horizontal rail controls */
(function () {
  // Manual rAF scroll. scrollBy/scrollTo with behavior:'smooth' is unreliable
  // on this site (snippets/dh-product-card.liquid documents the same problem
  // for page scrolling), and the rails' CSS scroll-behavior:smooth makes even
  // an instant scrollBy go through the same path. Animating scrollLeft
  // ourselves works regardless.
  function animateScroll(el, target) {
    var max = el.scrollWidth - el.clientWidth;
    if (target < 0) target = 0;
    if (target > max) target = max;
    var start = el.scrollLeft;
    var diff = target - start;
    if (Math.abs(diff) < 2) { el.scrollLeft = target; return; }
    var duration = 420, t0 = null;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var t = Math.min((ts - t0) / duration, 1);
      var e = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; // easeInOutQuad
      el.scrollLeft = start + diff * e;
      if (t < 1) requestAnimationFrame(frame);
    }
    if (window.requestAnimationFrame) requestAnimationFrame(frame);
    else el.scrollLeft = target;
  }

  function initRail(root) {
    var rail = root.querySelector('[data-dh-rail]');
    var prev = root.querySelector('[data-dh-rail-prev]');
    var next = root.querySelector('[data-dh-rail-next]');
    if (!rail) return;

    function step() {
      var first = rail.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) || 16;
      var w = first ? first.getBoundingClientRect().width : rail.clientWidth * 0.8;
      return (w + gap) * Math.max(1, Math.floor(rail.clientWidth / (w + gap)));
    }
    function update() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { animateScroll(rail, rail.scrollLeft - step()); });
    if (next) next.addEventListener('click', function () { animateScroll(rail, rail.scrollLeft + step()); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    initAutoscroll(root, rail);
  }

  // Optional auto-scroll. Advances one card per interval and loops.
  // Which widths it runs at comes from data-dh-autoscroll-scope:
  //   'mobile'  (default, and what this used to hardcode) | 'desktop' | 'all'
  function initAutoscroll(root, rail) {
    if (root.getAttribute('data-dh-autoscroll') !== 'true') return;
    var delay = parseInt(root.getAttribute('data-dh-autoscroll-speed'), 10) || 3000;
    var scope = root.getAttribute('data-dh-autoscroll-scope') || 'mobile';
    var query = '(max-width: 749px)';
    if (scope === 'desktop') query = '(min-width: 750px)';
    else if (scope === 'all') query = '(min-width: 0px)';
    var mq = window.matchMedia(query);
    var timer = null;

    function cardStep() {
      var first = rail.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) || 12;
      return first ? first.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function advance() {
      if (document.hidden) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (rail.scrollLeft >= max) animateScroll(rail, 0);
      else animateScroll(rail, rail.scrollLeft + cardStep());
    }
    function start() { if (!timer && mq.matches) timer = setInterval(advance, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // Pause while the user is interacting, resume afterwards.
    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) {
      rail.addEventListener(ev, stop, { passive: true });
    });
    ['touchend', 'mouseleave'].forEach(function (ev) {
      rail.addEventListener(ev, start, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    function onChange() { stop(); start(); }
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dh-rail-root]').forEach(initRail);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
